import { PaymentActivationStatus, PaymentMethod } from '@core/services/api/interfaces/payment-activation';

export type MeioDeRecebimento = PaymentMethod | 'link';

/** O formulário depende do meio contratado, mesmo sem tarifas personalizadas no plano. */
export function meioDeNovoCredenciamento(
  status: PaymentActivationStatus,
  permitido: (meio: PaymentMethod) => boolean = () => true,
): PaymentMethod | null {
  if (status.boleto.module && status.boleto.self_service && !status.boleto.registered && permitido('boleto')) {
    return 'boleto';
  }
  if (status.pix.module && status.pix.self_service && !status.pix.registered && permitido('pix')) {
    return 'pix';
  }
  if ((status.enrolled || !status.boleto.module) && status.card.module && status.card.self_service && !status.card.registered && permitido('card')) {
    return 'card';
  }
  return null;
}

/** Boleto, Pix e cartão dividem a tela "Meios de recebimento" (dono, 29/09/2026); o link tem a sua. */
export function meiosDaTela(meio: MeioDeRecebimento): MeioDeRecebimento[] {
  return meio === 'link' ? ['link'] : ['boleto', 'pix', 'card'];
}

/** Caminho da tela que apresenta o meio. */
export function caminhoDaTela(meio: MeioDeRecebimento): string {
  return meio === 'link' ? 'link' : 'boleto';
}

export function podeAbrirTela(status: PaymentActivationStatus, meio: MeioDeRecebimento): boolean {
  return meiosDaTela(meio).some(item => podeAbrirMeio(status, item));
}

export function podeAbrirMeio(status: PaymentActivationStatus, meio: MeioDeRecebimento): boolean {
  return meio === 'link' ? status.enrolled && status.link.module
    : status[meio].module && status[meio].registered;
}

export function primeiroMeio(
  status: PaymentActivationStatus,
  permitido: (meio: MeioDeRecebimento) => boolean,
): MeioDeRecebimento | null {
  for (const meio of ['boleto', 'pix', 'card', 'link'] as const) {
    if (permitido(meio) && podeAbrirMeio(status, meio)) {
      return meio;
    }
  }
  return null;
}
